import { render } from "./FormAlmacen.vue?vue&type=template&id=1760f13f"
import script from "./FormAlmacen.vue?vue&type=script&lang=js"
export * from "./FormAlmacen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__